import * as angular from 'angular';
import * as $ from 'jquery';
import * as _ from 'lodash';

import { DirectiveDefinition } from './directiveDefinition';

class FallbackIconController implements angular.IController {
    private _icon: string;
    
    static $inject = ['$attrs', '$element'];
    constructor(        private _$attrs: angular.IAttributes,
        private _$element: angular.IAugmentedJQuery) {
    }

    $onInit() {
        this._icon = '<i class="fa ' + this._$attrs.fallbackIcon + '" title="' + this._$attrs.title + '"></i>';
        this._$element.on('error', () => { $(this._$element).replaceWith(this._icon); });
    }

    $postLink() {
        if (_.isEmpty(this._$attrs.ngSrc)) {
            $(this._$element).replaceWith(this._icon);
        }
    }
}

export const FallbackIconDirective: DirectiveDefinition = {
    directiveId: 'fallbackIcon',
    restrict: 'A',
    controller: FallbackIconController,
};
